"use client";

import { ChevronRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Expertise() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const disciplines = [{
    number: "01",
    title: "Vehicle Negotiation",
    description: "We leverage deep market data to secure the best possible terms on your next vehicle purchase, ensuring you never overpay for your dream car.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723817/img/vehicle_negotiation.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723817/img/vehicle_negotiation.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723817/img/vehicle_negotiation.png-wvc-sizes",
    alt: "Professional reviewing car purchase documents"
  }, {
    number: "02",
    title: "HOME IMPROVEMENT",
    description: "Navigating the complexities of property acquisition with expert guidance. We represent your interests to ensure fair pricing and favorable contract conditions.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723817/img/real_estate_advocacy.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723817/img/real_estate_advocacy.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723817/img/real_estate_advocacy.png-wvc-sizes",
    alt: "Consultant discussing property investment strategy"
  }, {
    number: "03",
    title: "HOME REPAIRS",
    description: "From high-end electronics to specialized equipment, we handle the heavy lifting of negotiation so you can focus on enjoying your new acquisition.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723817/img/luxury_asset_sourcing.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723817/img/luxury_asset_sourcing.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1723817/img/luxury_asset_sourcing.png-wvc-sizes",
    alt: "Expert evaluating high-value luxury assets"
  }];
  return <section data-section-id="2840" id="expertise-at-a-glance" className="bg-background text-foreground py-32 md:py-40 lg:py-[10rem] overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16">
        {}
        <div ref={headerRef} className={`grid grid-cols-1 lg:grid-cols-[60%_40%] gap-10 lg:gap-16 mb-20 md:mb-28 transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div>
            <p className="font-default text-[11px] tracking-[0.25em] uppercase mb-8 md:mb-10" style={{
            color: "var(--primary)"
          }}>
              Our Expertise — 02
            </p>
            <h2 className="font-default text-5xl md:text-6xl lg:text-[5rem] leading-[1.05] tracking-tight text-primary font-bold uppercase">
              Strategic Advocacy.
              <br />
              Proven{" "}
              <em className="italic font-light" style={{
              color: "var(--primary)"
            }}>
                Results
              </em>
              .
            </h2>
          </div>
          <div className="flex items-end">
            <p className="font-default text-base md:text-[15px] leading-[1.7] max-w-md" style={{
            color: "var(--text-muted)"
          }}>
              At Price Advocate Services, we act as your tactical shield. We navigate 
              the complexities of high-stakes purchases, ensuring you retain your 
              hard-earned capital through expert negotiation and market insight.
            </p>
          </div>
        </div>

        {}
        <div ref={gridRef} className={`grid grid-cols-1 md:grid-cols-3 transition-all duration-1000 ease-out delay-200 ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {disciplines.map((item, i) => <article data-index={i} key={item.number} className="group relative aspect-[4/5] overflow-hidden border border-border hover:border-accent transition-all duration-700 cursor-pointer rounded-lg shadow-md">
              {}
              <div className="absolute inset-0 overflow-hidden">
                <img src={item.image} data-wvc-srcset={item.srcset} data-wvc-sizes={item.sizes} alt={item.alt} loading="lazy" decoding="async" className="w-full h-full object-cover transition-transform duration-[800ms] ease-out group-hover:scale-105" />
                {}
                <div className="absolute inset-0 transition-opacity duration-700" style={{
              background: "linear-gradient(180deg, hsla(217, 61%, 26%, 0.6) 0%, hsla(217, 61%, 26%, 0.8) 60%, hsla(217, 61%, 26%, 0.95) 100%)"
            }} />
              </div>

              {}
              <div className="absolute top-8 left-8 md:top-10 md:left-10 z-10">
                <span className="font-default text-[11px] tracking-[0.25em] text-accent">
                  {item.number}
                </span>
              </div>

              {}
              <div className="absolute bottom-8 right-8 md:bottom-10 md:right-10 z-10 transition-transform duration-500 group-hover:translate-x-1">
                <ChevronRight className="w-5 h-5 text-accent" strokeWidth={2} />
              </div>

              {}
              <div className="absolute bottom-8 left-8 md:bottom-10 md:left-10 right-16 md:right-20 z-10">
                <h3 className="font-default text-2xl md:text-3xl lg:text-[2rem] leading-tight text-white transition-transform duration-500 ease-out md:group-hover:-translate-y-2 font-bold uppercase">
                  {item.title}
                </h3>
                <p className="font-default text-sm leading-[1.65] mt-4 md:mt-0 md:opacity-0 md:max-h-0 md:overflow-hidden md:group-hover:opacity-100 md:group-hover:max-h-40 md:group-hover:mt-4 transition-all duration-500 ease-out text-white">
                  {item.description}
                </p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}